<template>
	<div>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card
					class="pa-3"
					height="auto">
					<v-layout row wrap>
						<v-flex xs6 text-xs-left>
							<label class="card-title">% Ocupación</label>
						</v-flex>
						<v-flex xs6 text-xs-right>
							<v-btn
								icon
								class="grey--text"
								@click="downloadReport">
								<v-icon>insert_drive_file</v-icon>
							</v-btn>
							<v-btn
								icon
								class="grey--text"
								@click="printReport">
								<v-icon>print</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs12 mb-3>
							<v-layout row wrap align-center>
								<v-flex xs7 text-xs-left>
									<v-layout row wrap align-center>
										<v-flex xs4 pr-3
											v-for="subsidiary in subsidiaries"
											:key="subsidiary.id">
											<v-layout row wrap align-center>
												<v-flex xs10 pr-0 text-xs-left>
													<span class="caption-color"
														:style="`background-color: ${subsidiary.color}`"></span>
													<label class="caption-text">{{ subsidiary.name }}</label>
												</v-flex>
												<v-flex xs2 pl-0 text-xs-right>
													<v-checkbox
														class="caption-checkbox"
														:disabled="subsidiary.isSelected && oneSelected"
														v-model="subsidiary.isSelected"
														@change="loadData">
													</v-checkbox>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs5 text-xs-right>
									<v-btn
										v-for="filter in filters"
										:key="filter.id"
										class="filter-btn-report"
										:class="{ 'active': filter.id === value }"
										@click="applyFilter(filter)"
										:disabled="loading">
										{{filter.label}}
									</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12>
							<vue-chart
								type="horizontalBar"
								:data="chartData"
								:options="optionsChart"
								class="report-container"
							></vue-chart>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<v-card
					class="pa-3"
					height="auto">
					<v-layout row wrap>
						<v-flex xs6 text-xs-left>
							<label class="card-title">% Ocupación</label>
						</v-flex>
						<v-flex xs6 text-xs-right>
							<v-btn
								icon
								class="grey--text"
								@click="downloadReport">
								<v-icon>insert_drive_file</v-icon>
							</v-btn>
							<v-btn
								icon
								class="grey--text"
								@click="printReport">
								<v-icon>print</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs12 mb-3>
							<v-layout row wrap align-center>
								<v-flex xs7 text-xs-left>
									<v-layout row wrap align-center>
										<v-flex xs4 pr-3
											v-for="subsidiary in subsidiaries"
											:key="subsidiary.id">
											<v-layout row wrap align-center>
												<v-flex xs10 pr-0 text-xs-left>
													<span class="caption-color"
														:style="`background-color: ${subsidiary.color}`"></span>
													<label class="caption-text">{{ subsidiary.name }}</label>
												</v-flex>
												<v-flex xs2 pl-0 text-xs-right>
													<v-checkbox
														class="caption-checkbox"
														:disabled="subsidiary.isSelected && oneSelected "
														v-model="subsidiary.isSelected"
														@change="loadGraphic">
													</v-checkbox>
												</v-flex>
											</v-layout>
										</v-flex>
										<v-flex xs4 pr-3>
											<v-layout row wrap align-center>
												<v-flex xs10 pr-0 text-xs-left>
													<span class="caption-color average"></span>
													<label class="caption-text">PROMEDIO</label>
												</v-flex>
												<v-flex xs2 pl-0 text-xs-right>
													<v-checkbox
														class="caption-checkbox"
														v-model="average"
														:true-value="1"
                            :false-value="0"
														@change="loadGraphic">
													</v-checkbox>
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12>
							<vue-chart
								type="bar"
								:data="barData"
								:options="optionsChart"
								class="report-container"
							></vue-chart>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
			<v-flex xs12>
				<v-card
					class="pa-3"
					height="auto">
					<v-layout row wrap align-center>
						<v-flex xs2>
							<v-select
								class="filter-select"
								item-text="name"
								item-value="id"
								:items="subsidiaries"
								hide-details
								v-model="idSubsidiary"
								@input="loadGraphicLineal"
								single-line
								bottom>
						</v-select>
						</v-flex>
						<v-flex xs2>
							<v-menu
								lazy
								v-model="menu"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								@input="changeIcon">
								<v-text-field
									slot="activator"
									label="Fecha de inicio"
									v-model="filterDate"
									prepend-icon="event"
									:append-icon="arrowIcon"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="filterDate"
									no-title
									@input="loadGraphicLineal"
									scrollable
									>
								</v-date-picker>
							</v-menu>
						</v-flex>
						<v-flex xs3 pl-4 text-xs-left>
							<label class="card-title">Habitaciones ocupadas {{ takenRooms }}%</label>
						</v-flex>
						<v-flex xs2 text-xs-left>
							<label class="card-title">Ingresos ${{ fee }}</label>
						</v-flex>
						<v-flex xs5 text-xs-right>
							<v-btn
								icon
								class="grey--text"
								@click="downloadReport">
								<v-icon>insert_drive_file</v-icon>
							</v-btn>
							<v-btn
								icon
								class="grey--text"
								@click="printReport">
								<v-icon>print</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs12 mt-3>
							<vue-chart
								type="line"
								:data="chartLineData"
								:options="optionsLineChart"
								class="report-container"
							></vue-chart>
						</v-flex>
					</v-layout>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import VueChart from 'vuechart';
	import { format, subWeeks, subMonths, subYears, subDays } from 'date-fns';
	import mixin from '@/shared/mixins';
	import lib from '@/shared/lib';

	const { find, equality } = lib;

	function created() {
		this.loadResources();
	}

	function applyFilter(filter) {
		this.value = filter.id;
		this.loadData();
	}

	function arrowIcon() {
		const arrow = this.icon ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function changeIcon() {
		this.icon = this.menu;
	}

	function downloadReport() {}


	async function loadData() {
		const filterSelected = this.filters.find(f => f.id === this.value);
		if (filterSelected.code === 'years') {
			this.chartByCities.dateStart = format(subYears(new Date(), 1), 'YYYY-MM-DD');
		} else if (filterSelected.code === 'months') {
			this.chartByCities.dateStart = format(subMonths(new Date(), 1), 'YYYY-MM-DD');
		} else {
			this.chartByCities.dateStart = format(subWeeks(new Date(), 1), 'YYYY-MM-DD');
		}
		const params = {
			dateStart: this.chartByCities.dateStart,
			dateEnd: this.chartByCities.dateEnd,
			subsidiariesId: this.subsidiaries.filter(s => s.isSelected).map(s => s.id).join(),
		};
		const { data: chart } = await this.$http.get(`${process.env.PMS_URL}/dashboard-occupation`,
			{ params });
		this.chartData = chart.data;
		if (Number(params.subsidiariesId)) {
			this.updateColor(this.updateChartData, this.subsidiaries, params.subsidiariesId);
		}
	}

	async function loadResources() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data.map((sub, index) => {
			const newSub = { ...sub };
			if (index === 0) {
				newSub.color = '#04bee9';
			}
			if (index === 1) {
				newSub.color = '#00cb28';
			}
			newSub.isSelected = true;
			return newSub;
		});
		this.idSubsidiary = subsidiaries.data[0].id;
		this.loadData();
		this.loadGraphic();
		this.loadGraphicLineal();
	}

	async function loadGraphic() {
		const params = {
			subsidiariesId: this.subsidiaries.filter(s => s.isSelected).map(s => s.id).join(),
			dateStart: format(subYears(new Date(), 1), 'YYYY-MM-DD'),
			dateEnd: format(new Date(), 'YYYY-MM-DD'),
			flagPercent: this.average,
		};
		const { data: chart } = await this.$http.get(`${process.env.PMS_URL}/dashboard-occupation/month?`,
		{ params });
		this.barData = chart.data;
		if (Number(params.subsidiariesId)) {
			this.updateColor(this.updateBarData, this.subsidiaries, params.subsidiariesId);
		}
	}

	async function loadGraphicLineal() {
		const params = {
			dateStart: format(subDays(this.filterDate, 7), 'YYYY-MM-DD'),
			dateEnd: format(this.filterDate, 'YYYY-MM-DD'),
			subsidiariesId: this.idSubsidiary,
		};
		const { data: chart } = await this.$http.get(`${process.env.PMS_URL}/dashboard-occupation/week?`, { params });
		this.chartLineData = chart.data;
	}

	function oneSelected() {
		return this.subsidiaries.filter(s => s.isSelected).length === 1;
	}

	function printReport() {}

	function updateColor(fn, subsidiaries, subsidiaryId) {
		const selectedSubsidiary = find(
			equality(
				'id',
				Number(subsidiaryId),
			),
			subsidiaries,
		);
		const { color } = selectedSubsidiary;
		fn(color);
	}

	function updateBarData(color) {
		const len = this.barData.datasets[0].backgroundColor.length;
		for (let i = 0; i < len; i += 1) {
			this.barData.datasets[0].backgroundColor[i] = color;
		}
	}

	function updateChartData(color) {
		this.chartData.datasets[0].backgroundColor[0] = color;
	}

	function data() {
		return {
			barData: {
				datasets: [{
					data: [],
					backgroundColor: [],
				}],
				labels: [],
			},
			chartByCities: {
				dateStart: format(subMonths(new Date(), 1), 'YYYY-MM-DD'),
				dateEnd: format(new Date(), 'YYYY-MM-DD'),
			},
			chartData: {
				datasets: [{
					data: [],
					backgroundColor: [],
				}],
				labels: [],
			},
			chartLineData: {
				datasets: [{
					data: [],
					backgroundColor: [],
				}],
				labels: [],
			},
			icon: false,
			fee: 0,
			filterDate: format(new Date(), 'YYYY-MM-DD'),
			filters: [
				{ id: 1, value: 1, label: 'Año', code: 'years' },
				{ id: 2, value: 2, label: 'Mes', code: 'months' },
				{ id: 3, value: 3, label: 'Semana', code: 'days' },
			],
			loading: false,
			menu: false,
			optionsChart: {
				legend: {
					display: false,
				},
				scales: {
					xAxes: [
						{
							ticks: {
								beginAtZero: true,
							},
						},
					],
				},
			},
			optionsLineChart: {
				legend: {
					display: false,
				},
				scales: {
					xAxes: [
						{
							ticks: {
								beginAtZero: true,
							},
						},
					],
				},
			},
			subsidiaries: [],
			takenRooms: 0,
			value: 2,
			average: 1,
			idSubsidiary: '',
		};
	}

	export default {
		name: 'report-occupancy',
		components: {
			[VueChart.name]: VueChart,
		},
		computed: {
			arrowIcon,
			oneSelected,
		},
		created,
		data,
		methods: {
			applyFilter,
			changeIcon,
			downloadReport,
			loadData,
			loadGraphic,
			loadGraphicLineal,
			loadResources,
			printReport,
			updateBarData,
			updateChartData,
			updateColor,
		},
		mixins: mixin,
	};
</script>

<style lang="scss" scoped>
	.download-icon {
		.icon {
			width: 24px;
		}
	}

	.caption {
		&-color {
			display: inline-block;
			height: 12px;
			margin-right: 10px;
			vertical-align: middle;
			width: 12px;
		}

		&-checkbox {
			background-color: transparent;
			box-shadow: none;
			min-height: auto;
		}
	}

	button.filter-btn-report {
		background-color: map-get($colors, default-button-color) !important;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		color: white;
		font-size: map-get($sizes, eleven) !important;
		height: 25px;
		line-height: 25px;
		margin-left: 16px;
		max-width: 66px;
		min-width: auto;

		&.active {
			background-color: map-get($colors, default-skyblue) !important;
			color: white;
		}
	}

	.card-title {
		color: map-get($colors, bg-chart);
		font-family: map-get($fonts, medium);
		font-size: map-get($sizes, fourteen);
	}

	.average {
		background-color: map-get($colors, check-average) !important;
	}
</style>


// WEBPACK FOOTER //
// Occupancy.vue?78f936ae